<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Заявки</div>
                  <div class="breadcrumb">Монитор продаж / Заявки</div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-container class="col-10">
              <Block :padding="0">
                <div class="filter">
                  <div class="top-line">
                    <div class="w-352">
                      <v-autocomplete colspan="1" :items="listClient ? listClient.client : []"
                                      item-value="client_id" item-text="name" placeholder="Поиск клиентов"
                                      no-data-text="Результатов не найдено" clearable color="#629F33"
                                      item-color="success" :search-input.sync="search" v-model="select" filled
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      class="rounded-lg" append-icon="" hide-details outlined dense
                                      background-color="white">
                        <template v-slot:prepend-inner>
                          <v-icon>mdi-magnify</v-icon>
                        </template>
                      </v-autocomplete>
                    </div>
                    <v-btn class="filter-btn" @click="showFilterGrid = !showFilterGrid">
                      <Icon :iconName="showFilterGrid ? 'x' : 'filter'" width=" 16" height="16"
                            viewBox="0 0 16 16" strockeWidth="2" stroke="#fff"/>
                      Фильтр
                    </v-btn>
                  </div>
                  <transition name="fade">
                    <div class="hidden-block" v-if="showFilterGrid">
                      <Grid :column="4" :gap="20" :customStyle="{ rowGap: 0 }">
                        <div class="filter__field">
                          <span class="label">Статус клиента</span>
                          <v-select
                              class="rounded-lg custom__select"
                              :items="[]"
                              item-title="title"
                              item-value="value"
                              item-text="title"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </div>
                        <div class="filter__field">
                          <span class="label">Клубы</span>
                          <v-select
                              class="rounded-lg custom__select"
                              :items="[]"
                              item-title="title"
                              item-value="value"
                              item-text="title"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </div>
                        <div class="filter__field">
                          <span class="label">Менеджер</span>
                          <v-select
                              class="rounded-lg custom__select"
                              :items="[]"
                              item-title="title"
                              item-value="value"
                              item-text="title"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </div>
                        <div class="filter__field">
                          <span class="label">Кем создан</span>
                          <v-select
                              class="rounded-lg custom__select"
                              :items="[]"
                              item-title="title"
                              item-value="value"
                              item-text="title"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </div>
                        <div class="filter__field">
                          <span class="label">Источник</span>
                          <v-select
                              class="rounded-lg custom__select"
                              :items="[]"
                              item-title="title"
                              item-value="value"
                              item-text="title"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </div>
                        <div class="filter__field">
                          <span class="label">Рекламная площадка</span>
                          <v-select
                              class="rounded-lg custom__select"
                              :items="[]"
                              item-title="title"
                              item-value="value"
                              item-text="title"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </div>
                        <div class="filter__field">
                          <span class="label">Создана</span>
                          <v-select
                              class="rounded-lg custom__select"
                              :items="[]"
                              item-title="title"
                              item-value="value"
                              item-text="title"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </div>
                        <div class="filter__field">
                          <span class="label">Пометка удаления</span>
                          <v-select
                              class="rounded-lg custom__select"
                              :items="[]"
                              item-title="title"
                              item-value="value"
                              item-text="title"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              placeholder="Значение" append-icon="mdi-chevron-down" outlined
                              dense
                          >
                          </v-select>
                        </div>
                        <div class="filter__field colspan-4 button-block">
                          <v-btn class="apply">
                            Применить
                          </v-btn>
                          <v-btn class="clear">
                            Очистить
                          </v-btn>
                        </div>
                      </Grid>
                    </div>
                  </transition>
                </div>
                <v-data-table
                    :headers="headersRequests"
                    :items="list.monitor"
                    no-data-text="Результатов не найдено"
                    :hide-default-footer="true"
                    :page="page"
                    class="elevation-1"
                >
                </v-data-table>
                <v-card-actions
                    class="d-flex justify-content-between"
                    style="padding: 20px !important;"
                >
                  <template>
                    <div></div>
                    <div>
                      <v-pagination
                          v-model="page"
                          circle
                          color="#629F33"
                          :length="Math.ceil(list.monitor.length / 10)"
                      ></v-pagination>
                    </div>
                  </template>
                </v-card-actions>
              </Block>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {monitorActionTypes} from "@/store/modules/monitor";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";

export default {
  name: 'Applications',
  props: ['specialist_id', 'type'],
  components: {
    Header,
    Menu,
  },
  computed: {
    ...mapState({
      isLoading: state => state.monitor.isLoading,
      list: state => state.monitor.list,
      validationErrors: state => state.monitor.validationErrors
    })
  },
  methods: {
    fetchFeed(specialist_id, type) {
      if (type === 'new') {
        this.$store.dispatch(monitorActionTypes.getNewRequests, {
          specialist_id
        })
      } else {
        this.$store.dispatch(monitorActionTypes.getProgressRequests, {
          specialist_id
        })
      }
    }
  },
  mounted() {
    this.specialist_id !== undefined ? setItem('requests-specialist_id', this.specialist_id) : this.specialist_id = JSON.parse(getItem('requests-specialist_id'));
    this.type !== undefined ? setItem('requests-type', this.type) : this.type = getItem('requests-type');
    this.fetchFeed(this.specialist_id, this.type);
  },
  data() {
    return {
      select: null,
      showFilterGrid: false,
      page: 1,
      headersRequests: [
        {text: 'ФИО', align: 'start', sortable: false, value: 'user.name'},
        {text: 'Создана', align: 'start', value: 'date_creation'},
        {text: 'Статус', align: 'start', value: 'status'},
        {text: 'Номер телефона', align: 'start', value: 'phone'},
        {text: 'Менеджер', align: 'start', value: 'manager.name'},
        {text: 'Площадка', align: 'start', value: 'square'},
        {text: 'Источник', align: 'start', value: 'source'},
        {text: 'Кем создан', align: 'start', value: 'user.name'},
        {text: 'Оценка заявки', align: 'start', value: 'rate'},
        {text: 'Структурная еденица', align: 'start', value: 'club.name'},
      ]
    }
  }
}
</script>
<style scoped lang="scss">
.filter {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }
    }

  }

  .hidden-block {
    padding-top: 20px;

  }

  &__field {
    &.colspan-4 {
      grid-column: 1 / 5;
    }

    &.button-block {
      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .label {
      color: #1A1A1A;
      display: block;
      margin-bottom: 8px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  button {
    border-radius: 12px;
    text-transform: none;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    box-shadow: none;
    padding: 13px 21px;

    &.apply {
      background: #629F33 !important;
      color: #fff !important;
    }

    &.clear {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
    }

  }
}

.min-w-173 {
  min-width: 173px;
}

.client {
  display: flex;
  align-items: center;

  .ava {
    margin-right: 8px;
  }
}
</style>